<template>
  <Transition name="vip-prompt-fade">
    <div v-if="modelValue" class="vip-prompt-mask" @click.stop="handleMaskClick">
      <section class="vip-prompt-modal" role="dialog" aria-modal="true" @click.stop>
        <button
          v-if="showClose"
          type="button"
          class="vip-prompt-close"
          :aria-label="closeAriaLabel"
          @click="close"
        >
          <font-awesome-icon icon="xmark" />
        </button>

        <!-- <div class="vip-prompt-icon" aria-hidden="true">
          <font-awesome-icon icon="crown" />
        </div> -->

        <h3 class="vip-prompt-title">{{ title }}</h3>
        <p class="vip-prompt-desc">{{ description }}</p>

        <div class="vip-prompt-actions">
          <button type="button" class="vip-prompt-secondary" @click="cancel">
            {{ secondaryText }}
          </button>
          <button type="button" class="vip-prompt-primary" @click="confirm">
            {{ primaryText }}
          </button>
        </div>
      </section>
    </div>
  </Transition>
</template>

<script setup>
/* global defineProps, defineEmits */
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '温馨提示',
  },
  description: {
    type: String,
    default: '\u6210\u4e3a\u4f1a\u5458\u540e\u53ef\u89c2\u770b\u5b8c\u6574\u5185\u5bb9',
  },
  secondaryText: {
    type: String,
    default: '\u7a0d\u540e\u518d\u8bf4',
  },
  primaryText: {
    type: String,
    default: '\u5f00\u901a\u4f1a\u5458',
  },
  closeAriaLabel: {
    type: String,
    default: '\u5173\u95ed',
  },
  showClose: {
    type: Boolean,
    default: true,
  },
  closeOnMask: {
    type: Boolean,
    default: true,
  },
  closeOnConfirm: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:modelValue', 'cancel', 'confirm', 'close'])

const close = () => {
  emit('update:modelValue', false)
  emit('close')
}

const cancel = () => {
  close()
  emit('cancel')
}

const confirm = () => {
  if (props.closeOnConfirm) {
    close()
  }

  emit('confirm')
}

const handleMaskClick = () => {
  if (props.closeOnMask) {
    close()
  }
}
</script>

<style scoped>
.vip-prompt-mask {
  position: fixed;
  inset: 0;
  z-index: 2400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(51, 41, 30, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.vip-prompt-modal {
  position: relative;
  width: min(380px, 100%);
  padding: 32px 24px 24px;
  border-radius: 24px;
  background: linear-gradient(180deg, #fffdf8 0%, #fff4e8 100%);
  border: 1px solid rgba(255, 183, 99, 0.34);
  box-shadow:
    0 24px 52px rgba(126, 85, 43, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  text-align: center;
}

.vip-prompt-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #b49b82;
  font-size: 20px;
  cursor: pointer;
}

.vip-prompt-icon {
  width: 58px;
  height: 58px;
  margin: 0 auto 16px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff8db;
  font-size: 25px;
  background: linear-gradient(135deg, #ffc864 0%, #ff8b2f 100%);
  box-shadow: 0 14px 28px rgba(255, 139, 47, 0.28);
}

.vip-prompt-title {
  margin: 0;
  color: #2d3436;
  font-size: 21px;
  font-weight: 900;
  line-height: 1.2;
}

.vip-prompt-desc {
  margin: 12px 0 0;
  color: #7c6757;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
}

.vip-prompt-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 24px;
}

.vip-prompt-secondary,
.vip-prompt-primary {
  min-height: 44px;
  border: none;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.vip-prompt-secondary {
  background: rgba(241, 232, 222, 0.9);
  color: #7b6b5e;
}

.vip-prompt-primary {
  background: linear-gradient(135deg, #ff8b2f 0%, #ff6d16 100%);
  color: #ffffff;
  box-shadow: 0 10px 18px rgba(255, 122, 24, 0.24);
}

.vip-prompt-secondary:hover,
.vip-prompt-primary:hover {
  transform: translateY(-1px);
}

.vip-prompt-primary:hover {
  box-shadow: 0 12px 22px rgba(255, 122, 24, 0.3);
}

.vip-prompt-fade-enter-active,
.vip-prompt-fade-leave-active {
  transition: opacity 0.22s ease;
}

.vip-prompt-fade-enter-from,
.vip-prompt-fade-leave-to {
  opacity: 0;
}
</style>
